// Audio file-based sound engine
import bidClickSrc from '../sounds/bid_click.wav';
import gavelSrc from '../sounds/gavel_finale.wav';
import yourTurnSrc from '../sounds/your_turn.wav';
import targetSrc from '../sounds/target_alert.wav';
import heartbeatSrc from '../sounds/heartbeat.wav';
import ffCrowd from '../sounds/ff_crowd.mp3';
import ffAuctioneer from '../sounds/ff_auctioneer.mp3';
import ffCaller from '../sounds/ff_caller.mp3';
import amb1 from '../sounds/ambiance_crowd.mp3';
import amb2 from '../sounds/ambiance_auctioneer.mp3';
import amb3 from '../sounds/ambiance_caller.mp3';
import winSrc from '../sounds/theburntpeanut-hooray.wav';

function loadAudio(src) {
  const a = new Audio(src);
  a.preload = 'auto';
  return a;
}

const ambSources = [amb1, amb2, amb3];
const ffSources = [ffCrowd, ffAuctioneer, ffCaller];
let ambAudio = null;
let lastAmbIndex = -1;
let ffAudio = null;
let ffPlaying = false;
let hbAudio = null;
let hbInterval = null;
let hbPlaying = false;

const SoundEngine = {
  muted: false,

  playBid() {
    if (this.muted) return;
    const a = loadAudio(bidClickSrc);
    a.volume = 0.25;
    a.play().catch(() => {});
  },

  playSold() {
    if (this.muted) return;
    const a = loadAudio(gavelSrc);
    a.volume = 0.1;
    a.play().catch(() => {});
  },

  playWin() {
    if (this.muted) return;
    const a = loadAudio(winSrc);
    a.volume = 0.5;
    a.play().catch(() => {});
  },

  playYourTurn() {
    if (this.muted) return;
    const a = loadAudio(yourTurnSrc);
    a.volume = 0.6;
    a.play().catch(() => {});
  },

  playGoingOnce() {},
  playGoingTwice() {},

  playTarget() {
    if (this.muted) return;
    const a = loadAudio(targetSrc);
    a.volume = 0.6;
    a.play().catch(() => {});
  },

  playNomination() {},

  startAmbiance() {
    if (ambAudio) return;
    let idx = Math.floor(Math.random() * ambSources.length);
    if (ambSources.length > 1 && idx === lastAmbIndex) idx = (idx + 1) % ambSources.length;
    lastAmbIndex = idx;
    ambAudio = loadAudio(ambSources[idx]);
    ambAudio.loop = true;
    ambAudio.volume = 0;
    ambAudio.play().catch(() => {});
  },

  rotateAmbiance() {
    if (ambAudio) { ambAudio.pause(); ambAudio = null; }
    if (this.muted) return;
    let idx = Math.floor(Math.random() * ambSources.length);
    if (ambSources.length > 1 && idx === lastAmbIndex) idx = (idx + 1) % ambSources.length;
    lastAmbIndex = idx;
    ambAudio = loadAudio(ambSources[idx]);
    ambAudio.loop = true;
    ambAudio.volume = 0;
    ambAudio.play().catch(() => {});
  },

  setAmbianceIntensity(intensity) {
    if (!ambAudio || this.muted) return;
    ambAudio.volume = Math.min(0.22, intensity * 0.22);
  },

  pauseAmbiance() {
    if (ambAudio) ambAudio.pause();
  },

  resumeAmbiance() {
    if (ambAudio && !this.muted) ambAudio.play().catch(() => {});
  },

  stopAmbiance() {
    if (!ambAudio) return;
    ambAudio.pause();
    ambAudio.currentTime = 0;
    ambAudio = null;
  },

  startFastForward() {
    if (this.muted || ffPlaying) return;
    if (ambAudio) ambAudio.pause();
    ffPlaying = true;
    const src = ffSources[Math.floor(Math.random() * ffSources.length)];
    ffAudio = loadAudio(src);
    ffAudio.loop = true;
    ffAudio.volume = 0.15;
    ffAudio.play().catch(() => {});
  },

  stopFastForward() {
    if (!ffAudio) return;
    ffAudio.pause();
    ffAudio.currentTime = 0;
    ffAudio = null;
    ffPlaying = false;
    if (ambAudio && !this.muted) ambAudio.play().catch(() => {});
  },

  startHeartbeat(bpm = 55) {
    if (hbInterval) clearInterval(hbInterval);
    hbPlaying = true;
    const beat = () => {
      if (this.muted) return;
      const a = loadAudio(heartbeatSrc);
      a.volume = 0.85;
      a.play().catch(() => {});
    };
    beat();
    hbInterval = setInterval(beat, (60 / bpm) * 1000);
  },

  setBPM(bpm) {
    if (!hbPlaying) return;
    if (hbInterval) clearInterval(hbInterval);
    const beat = () => {
      if (this.muted) return;
      const a = loadAudio(heartbeatSrc);
      a.volume = 0.85;
      a.play().catch(() => {});
    };
    hbInterval = setInterval(beat, (60 / bpm) * 1000);
  },

  stopHeartbeat() {
    if (hbInterval) clearInterval(hbInterval);
    hbInterval = null;
    hbAudio = null;
    hbPlaying = false;
  },
};

export default SoundEngine;
